import CombineSentences from "../../components/ClassOne/English/CombineSentences";
import CorrectFormGerunds from "../../components/ClassOne/English/CorrectFormGerunds";
import FillPrepositionGerunds from "../../components/ClassOne/English/FillPrepositionGerunds";
import FindUnderlineGerunds from "../../components/ClassOne/English/FindUnderlineGerunds";
import IdentifyGerund from "../../components/ClassOne/English/IdentifyGerunds";
import SpotError from "../../components/ClassOne/English/SpotError";
import WordBankActivity from "../../components/ClassOne/English/WordBankActivity";

// Define the type for menu items
interface MenuItem {
    url: string;
    title: string;
    component?: React.FC; // Optional React functional component
    subMenu?: MenuItem[]; // Allow subMenu to be an array of MenuItem
}


const topics: MenuItem[] = [
    { url: "/class-one/english/nouns/gerunds/indentify", title: "Identify the Gerund", component: IdentifyGerund },
    { url: "/class-one/english/nouns/gerunds/combine-sentences", title: "Combine Sentences", component: CombineSentences },
    { url: "/class-one/english/nouns/gerunds/find-underline", title: "Find Gerund Phrase", component: FindUnderlineGerunds },
    { url: "/class-one/english/nouns/gerunds/fill-prepositions", title: "Fill Prepositions", component: FillPrepositionGerunds },
    { url: "/class-one/english/nouns/gerunds/word-bank-activity", title: "Word Bank Activity", component: WordBankActivity },
];


export default topics;